/**
 * Client-side PWA mode: ?view=pwa OR progressify-me localStorage isInApp === true
 */
(function () {
  const STORAGE_KEY = 'progressify-me';

  function isInAppFromStorage() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      const data = JSON.parse(raw);
      return !!(data && data.isInApp === true);
    } catch (e) {
      return false;
    }
  }

  function isPwaFromUrl() {
    return new URLSearchParams(window.location.search).get('view') === 'pwa';
  }

  window.PwaMode = {
    isInAppFromStorage,
    isPwaFromUrl,
    isPwaMode() {
      return isPwaFromUrl() || isInAppFromStorage();
    },
  };
})();
